import { RestLink } from "apollo-link-rest";

import {
  HTTP_STATUS_BAD_REQUEST,
  HTTP_STATUS_FOUND,
  HTTP_STATUS_OK,
  HTTP_STATUS_UNAUTHORIZED,
} from "@/constants/http.constants";
import { setResponseWithHeaders } from "./setResponseWithHeaders";

export async function customFetch(
  uri: RequestInfo,
  config: RequestInit
): Promise<Response> {
  const res = await fetch(uri, config);
  let data;

  try {
    data = await res.clone().json();
  } catch (e) {
    data = await res.clone().text();
  }

  if (res.status >= HTTP_STATUS_BAD_REQUEST) {
    const error = new Error("Response not successful") as RestLink.ServerError;
    error.response = res;
    error.statusCode = res.status;
    // For 401 we do not keep the data otherwise apollo can interpret it as a graphql error and calls errorLink twice
    error.result = res.status === HTTP_STATUS_UNAUTHORIZED ? {} : data;
    throw error;
  }

  // Edge case: a 200 with an empty body and no Content-Length header.
  // Apollo cannot parse that JSON unless Content-Length is "0".
  // https://github.com/apollographql/apollo-link-rest/issues/107
  if (res.status === HTTP_STATUS_OK && !data) {
    return setResponseWithHeaders(res, (headers) => {
      headers.set("Content-Length", "0");
      return headers;
    });
  }

  if (res.status === HTTP_STATUS_FOUND) {
    const location = res.headers.get("Location");
    if (location) {
      return fetch(location, config);
    }
  }

  return res;
}
